import axios, { AxiosResponse } from "axios";
import { getUserToken } from "utils/getToken";

export const ApiImageBaseURL = process.env.REACT_APP_API_IMAGE_URL || "";
export const ApiCMSGraphql = process.env.REACT_APP_API_CMS_URL;

export const getImageCmsURL = (path: string) =>
  encodeURI(/^https?:\/\//i.test(path) ? path : ApiImageBaseURL.concat("/", path));

export const ApiCMSInstance = axios.create({
  baseURL: ApiCMSGraphql,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: getUserToken(),
  },
  method: "POST",
});

export async function ApiCMSRequest<responseDataType = any>({
  query,
  variables,
}: {
  query: string;
  variables?: { [key: string]: any };
}): Promise<AxiosResponse<{ data?: responseDataType; errors?: Error[] }>> {
  return ApiCMSInstance.request<{
    data?: responseDataType;
    errors?: Error[];
  }>({
    data: {
      query,
      variables,
    },
    headers: {
      // ...headers,
      Authorization: localStorage.getItem("UserToken"),
    }, // Passe os cabeçalhos para a requisição
  });
}

export type responseApiCMSRequest<responseDataType = any> = AxiosResponse<{
  data?: responseDataType;
  errors?: Error[];
}>;

export interface DataState<DataType = any> {
  loading?: boolean;
  error?: Error;
  data?: DataType;
}

export async function ApiCMSWithSetData<T = any>({
  query,
  variables,
  setData,
}: {
  query: string;
  variables?: { [key: string]: any };
  setData: (data: DataState<T>) => void;
}): Promise<DataState<T>> {
  return ApiCMSRequest<T>({ query, variables })
    .then((response) => {
      if (!response?.data?.data) {
        const respError: DataState<T> = {
          loading: false,
          error: response?.data?.errors?.[0] || new Error("mediaFiles not found"),
          data: undefined,
        };
        setData(respError);
        return respError;
      }
      const respSuccess: DataState<T> = {
        error: undefined,
        loading: false,
        data: response.data.data,
      };
      setData(respSuccess);
      return respSuccess;
    })
    .catch((error) => {
      console.error(error);
      const respError: DataState<T> = {
        loading: false,
        error,
        data: undefined,
      };
      setData(respError);
      return respError;
    });
}
